import Schema from './Schema'
import FieldCheckTree from '../fields/FieldCheckTree'
export default class SchemaCheckbox extends Schema {
  constructor(label, key, items, rules, options, on) {
    super(options)
    FieldCheckTree.call(this, label, key, items, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaCheckTree.js